import * as d3 from 'd3';
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    width,
    height,
    initialWidth,
    initialHeight,
    data,
    margins,
    x,
    xAxis,
    y,
    yAxis,
    colorScale,
  } = props;

  const xTicks = isMobile ? 1 : 1;
  const [min] = x.domain();

  const newLeftMargin = 100;
  const newRightMargin = 40;
  const g = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight)
    .append('g')
    .attr('transform', `translate(${[newLeftMargin, margins.top]})`);

  // Adjust the x scale to account for the larger left margin
  const xScaleAdjusted = x.copy().range([0, width - newLeftMargin]);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(xScaleAdjusted).ticks(xTicks).tickFormat(d => d3.format('.0%')(d / 100)).tickSize(-height));

  xGrid.selectAll('text')
    .attr('y', 10);

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y));

  yGrid.selectAll('text').remove();

  const group = g.append('g')
    .attr('class', 'data');

  // Bars and Labels
  const serie = group.selectAll('g')
    .data(data)
    .enter().append('g')
    .style('fill', d => colorScale(d.key))
    .selectAll('g')
    .data(d => d)
    .enter()
    .append('g')
    .attr('class', 'serie')
    .attr('transform', d => `translate(${[xScaleAdjusted(d[0]), y(d.data.label)]})`);

  // Adding the bars with full width
  serie.append('rect')
    .attr('width', d => xScaleAdjusted(d[1]) - xScaleAdjusted(d[0]))
    .attr('height', y.bandwidth());

  const text = serie.filter((d) => {
  // Special case for the 'Unknown' label
    if (d.data.label === 'Unknown') return true;
    const x0 = x(d[1]) - x(d[0]);
    const breakpoint = isMobile ? 0.2 : 0.05;
    return x0 > width * breakpoint;
  });
  text.append('text')
    .attr('class', 'label')
    .attr('x', -5)
    .attr('y', y.bandwidth() / 2)
    .attr('dy', '.35em')
    .attr('text-anchor', 'end')
    .text(d => d.data.label)
    .style('font-size', '12px')
    .style('fill', 'black')
    .style('font-weight', '300');

  // Adding percentage values on the bars at the right end of the bars
  const valueText = serie.filter((d) => {
    const x0 = x(d[1]) - x(d[0]);
    const breakpoint = isMobile ? 0.2 : 0.05;
    return x0 > width * breakpoint || d.data.label === 'Unknown'; // Ensure 'Unknown' is always included
  });

  valueText.append('text')
    .attr('class', 'value')
    .attr('x', (d) => {
      if (d.data.label === 'Unknown' && isMobile) {
        return xScaleAdjusted(d[1]) + 5; // Move text outside for 'Unknown' on mobile
      }
      return xScaleAdjusted(d[1]) - 5; // Normal positioning for other bars
    })
    .attr('y', y.bandwidth() / 2)
    .attr('dy', '.35em')
    .attr('text-anchor', d => ((d.data.label === 'Unknown' && isMobile) ? 'start' : 'end'))
    .style('font-size', '12px')
    .style('fill', d => ((d.data.label === 'Unknown' && isMobile) ? '#262626' : 'white')) // Change color for 'Unknown'
    .text((d) => {
      const value = (d[1] - d[0]) / 100;
      return value >= 0 ? d3.format('.0%')(value) : '';
    });


  // Remove the "0%" label and the corresponding gray line from the x-axis
  xGrid.selectAll('.tick')
    .filter(d => d === 0)
    .remove();
}
